import { ComponentWithPermissions } from '../../../../../../baseComponents/CreateRoutering/types'
import BaseScreenTable from '../../../../../../baseComponents/TwinTable/BaseScreenTable'
import TableBuyInvoices from '../../../../../../specificComponents/buys/TableBuyInvoices'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import ModalCreateBuyInvoice from './ModalCreateBuyInvoice'

interface BuyInvoicesProps extends ComponentWithPermissions { }

const BuyInvoices: React.FC<BuyInvoicesProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()

    const pageData = {
        title: t('buyInvoices', 'Facturas'),
        newText: t('newBuyInvoice', 'Nueva factura'),
    }

    return (
        <BaseScreenTable TableComponent={TableBuyInvoices} CreateModalComponent={ModalCreateBuyInvoice} pageData={pageData} userPermissions={userPermissions} />
    )
}

export default BuyInvoices